import React from 'react';
import PropTypes from 'prop-types';
import { Badge, Card, Col, Row } from 'react-bootstrap-5';

import ItemHeader from './project_card/item_header';

export default class ProjectCard extends React.Component {
  static propTypes = {
    bare: PropTypes.bool.isRequired,
    bodyObjects: PropTypes.arrayOf(PropTypes.node),
    children: PropTypes.node,
    className: PropTypes.string,
    name: PropTypes.string,
    pillLabelText: PropTypes.string,
    rightActions: PropTypes.arrayOf(PropTypes.node),
    rightActionText: PropTypes.node,
    wrapBody: PropTypes.bool.isRequired,
    onRightAction: PropTypes.func
  };

  static defaultProps = {
    bare: false,
    className: 'overview-panel',
    format: 'full',
    wrapBody: false
  }

  doRightAction = (e) => {
    e.preventDefault();
    this.props.onRightAction();
  }

  renderPillLabel() {
    if (this.props.pillLabelText) {
      return (
        <Badge className="text-uppercase" name="pill-label">
          {this.props.pillLabelText}
        </Badge>
      );
    }
  }

  willRenderRightAction() {
    return this.props.rightActionText && this.props.onRightAction;
  }

  renderRightAction() {
    if (this.willRenderRightAction()) {
      return (
        <div className="text-end text-nowrap">
          <a
            className="btn-link float-end text-nowrap"
            href="#"
            name="card-right-action"
            onClick={this.doRightAction}
          >
            <small>{this.props.rightActionText}</small>
          </a>
        </div>
      );
    }

    if (this.props.rightActions && this.props.rightActions.length > 0) {
      const actions = this.props.rightActions.map((node, i) => {
        const spanClass = i < this.props.rightActions.length - 1
          ? 'align-middle me-5'
          : 'align-middle';
        return (
          <span className={spanClass} key={i}>{node}</span>
        );
      });
      return (
        <div className="d-flex flex-nowrap gap-4 align-items-center">
          {actions}
        </div>
      );
    }
  }

  renderOneBodyObject(object, index) {
    const keyValue = object.key ? `object-${object.key}` : `key-${index}`;

    return (
      <li className="list-group-item project-card-row border-bottom" key={keyValue} name="taskRow">
        {object}
      </li>
    );
  }

  renderBodyObjects() {
    return (
      <ul className="list-group">
        {this.props.bodyObjects.map(this.renderOneBodyObject)}
      </ul>
    );
  }

  renderMainBody() {
    if (this.props.bodyObjects) {
      return this.renderBodyObjects();
    }

    return this.props.children;
  }

  renderBody() {
    if (this.props.wrapBody) {
      return <Card.Body>{this.renderMainBody()}</Card.Body>;
    } else {
      return this.renderMainBody();
    }
  }

  renderBareCard() {
    return (
      <>
        <Card.Header>
          <Row className="align-items-center">
            <Col className="align-items-center gap-4">
              <span className="fs-large fw-semibold">
                {this.props.name}
              </span>
              {this.renderPillLabel()}
            </Col>
            <Col xs="auto">
              {this.renderRightAction()}
            </Col>
          </Row>
        </Card.Header>
        {this.renderBody()}
      </>
    );
  }

  renderFullCard() {
    return (
      <Card className={this.props.className}>
        {this.props.name ? this.renderBareCard() : this.renderBody()}
      </Card>
    );
  }

  render() {
    if (this.props.bare) {
      return this.renderBareCard();
    } else {
      return this.renderFullCard();
    }
  }
}

ProjectCard.ItemHeader = ItemHeader;
